import { useTranslation } from "react-i18next";
import React from "react";

export function useProducts() {
  const { t } = useTranslation();

  const products = React.useMemo(
    () => [
      {
        id: "furniture",
        name: t("categories.furniture"),
        description: t("categories.decorationsDescription", {
          // Astuce : si tu veux une clé dédiée plus tard, ajoute "furnitureDescription" dans i18n.
          defaultValue:
            "Furniture selections to elevate your event (tables, chairs, sofas, lounge, decorative setup).",
        }),
        imageUrl: "https://picsum.photos/400/200?random=201",
      },
      {
        id: "structuresAndTents",
        name: t("categories.structuresAndTents"),
        description: t("categories.structuresAndTentsDescription", {
          defaultValue:
            "Tents, marquees, flooring, risers and stages to shape your spaces.",
        }),
        imageUrl: "https://picsum.photos/400/200?random=202",
      },
      {
        id: "lightingAndEffects",
        name: t("categories.lightingAndEffects"),
        description: t("categories.lightingAndEffectsDescription", {
          defaultValue:
            "Architectural/ambient lighting, string lights and light special effects.",
        }),
        imageUrl: "https://picsum.photos/400/200?random=203",
      },
      {
        id: "technologyAndAV",
        name: t("categories.technologyAndAV"),
        description: t("categories.technologyAndAVDescription", {
          defaultValue:
            "State-of-the-art audio and visual equipment (screens, projectors, microphones).",
        }),
        imageUrl: "https://picsum.photos/400/200?random=204",
      },
      {
        id: "photographyAndVideography",
        name: t("categories.photographyAndVideography"),
        description: t("categories.photographyAndVideographyDescription", {
          defaultValue:
            "Photobooth kits, backdrops, visual props, supports and capture accessories.",
        }),
        imageUrl: "https://picsum.photos/400/200?random=205",
      },
      {
        id: "merchAndGifts",
        name: t("categories.merchAndGifts"),
        description: t("categories.merchAndGiftsDescription", {
          defaultValue:
            "Custom favors, stationery, labels and branded merchandise.",
        }),
        imageUrl: "https://picsum.photos/400/200?random=206",
      },
    ],
    [t]
  );

  return products;
}
